<div class="lesson-form-container">
  <h2>Lesson Form</h2>
  <p>Esto es dentro del componente de la leccion</p>
  <!-- Form implementation will go here -->
</div>
